export default __webpack_public_path__ + "static/media/size-chart.27d5967a.jpg";